(function() {
  const MIN_ORDER = 7450;

  function checkMinOrder() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const total = cart.total_price / 100;
        const blocked = total < MIN_ORDER;

        const checkoutBtns = document.querySelectorAll('[name="checkout"], .cart__checkout-button, #checkout');

        checkoutBtns.forEach(btn => {
          btn.disabled = blocked;
          btn.style.opacity = blocked ? '0.4' : '1';
          btn.style.cursor = blocked ? 'not-allowed' : 'pointer';
        });
      });
  }

  document.addEventListener('DOMContentLoaded', checkMinOrder);
  document.addEventListener('cart:updated', checkMinOrder);
  setInterval(checkMinOrder, 1500);
})();
